import Message from "../../message";
import EventBus from "@/services/eventBus";

export default class AchievementProgress extends Message
{
    handle()
    {
        EventBus.emit('achievement-progress', this.message);
    }
}
